module.exports = __webpack_public_path__ + "img/play.a6713b6a.svg";